export const siteInfo = {
  name: '黑料爆料',
  slogan: '今日新瓜 · 首发抢先看',
  description:
    '黑料爆料是专注娱乐与网络热点的实时情报站，汇集今日新瓜、首发抢先看与实时更新列表，把最新讨论第一时间摆在首页。',
  email: 'tips@heiliaobaoliao.example',
  workTime: '每日 09:00 - 23:30 实时值守',
  updateNote: '情报流全天滚动更新，热门事件平均 6 分钟内进入首页',
};

export const heroStats = [
  { value: '9.8万', label: '今日最高热度' },
  { value: '6 分钟', label: '平均上首页' },
  { value: '42 条', label: '今日新增内容' },
];

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '今日新瓜', to: '/#feed' },
  { label: '专题分类', to: '/topics' },
  { label: '热榜', to: '/#rank' },
  { label: '常见问题', to: '/#faq' },
  { label: '关于我们', to: '/about' },
];

export const categoryList = [
  { id: 'all', name: '全部', icon: 'ri-flashlight-fill', desc: '全部圈子最新动态' },
  { id: 'ent', name: '娱乐圈', icon: 'ri-movie-2-line', desc: '荧幕内外的最新动向' },
  { id: 'web', name: '网红圈', icon: 'ri-live-line', desc: '直播间与短视频平台风向' },
  { id: 'show', name: '综艺瓜', icon: 'ri-tv-2-line', desc: '热播综艺的话题与争议' },
  { id: 'film', name: '影视剧', icon: 'ri-clapperboard-line', desc: '剧集与电影的口碑走向' },
  { id: 'music', name: '音乐现场', icon: 'ri-mic-line', desc: '演出、音综与音乐话题' },
  { id: 'esports', name: '电竞圈', icon: 'ri-gamepad-line', desc: '赛事结果与选手动态' },
  { id: 'life', name: '情感八卦', icon: 'ri-heart-3-line', desc: '情侣、婚恋与情感风波' },
  { id: 'hot', name: '网络热点', icon: 'ri-fire-line', desc: '全网正在讨论的公共话题' },
];

export const flashList = [
  '【首发】某热播综艺分组名单疑似外泄，站内已整理完整时间线',
  '【升热】电竞联赛春季赛爆冷，卫冕队伍止步八强引发热议',
  '【更新】某头部主播直播回应争议，站内已补充当事双方说法',
  '【新瓜】都市剧《雨巷口》大结局口碑两极，观众评分实时下滑',
  '【跟进】音乐节档期调整，多支乐队行程出现变动',
  '【核实】网传某演员更换经纪团队，暂无官方口径，标记为待确认',
  '【升热】情感话题「异地三年」登上讨论榜，评论区出现大量真实经历',
  '【首发】某短视频达人账号内容风格突变，粉丝猜测团队换血',
];

export const newsList = [
  {
    id: 'n01',
    title: '某热播综艺分组名单流出，站内还原从路透到官宣的完整时间线',
    excerpt:
      '从最早的一条模糊路透，到节目组深夜发布说明，整件事在十二小时内完成三次反转。我们把公开可见的时间节点按顺序排好，方便你一次看懂来龙去脉。',
    categoryId: 'show',
    categoryName: '综艺瓜',
    time: '6 分钟前',
    date: '2026-09-12 21:04',
    heat: 98200,
    comments: 3412,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20magazine%20style%20image%20with%20deep%20charcoal%20backdrop%2C%20soft%20crimson%20spotlight%20haze%20and%20a%20single%20glowing%20spotlight%20cone%20on%20an%20empty%20theatre%20stage%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%20scene%20with%20film%20grain&width=800&height=560&seq=gg-cover-01&orientation=landscape',
    tags: ['首发', '综艺', '时间线'],
    author: '值班编辑 · 小满',
  },
  {
    id: 'n02',
    title: '电竞联赛爆冷止步八强，教练赛后采访一句话冲上讨论榜',
    excerpt:
      '卫冕队伍在关键局连续两次失误，赛后发布会上教练的简短回应被反复转发。有人说是状态问题，也有人翻出了赛季初的阵容变动记录。',
    categoryId: 'esports',
    categoryName: '电竞圈',
    time: '24 分钟前',
    date: '2026-09-12 20:46',
    heat: 86400,
    comments: 2870,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20esports%20arena%20abstract%20scene%20with%20deep%20charcoal%20background%20and%20cold%20teal%20stage%20lights%2C%20empty%20gaming%20desk%20with%20faint%20glow%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%2C%20no%20people%20visible&width=800&height=560&seq=gg-cover-02&orientation=landscape',
    tags: ['升热', '电竞', '争议'],
    author: '值班编辑 · 阿灰',
  },
  {
    id: 'n03',
    title: '某头部主播深夜开播回应，站内同步整理双方公开说法对照表',
    excerpt:
      '整场直播持续了两个半小时，核心回应集中在四点。我们把直播中公开表述与另一方此前发布的说明并列放在一起，方便你自己判断。',
    categoryId: 'web',
    categoryName: '网红圈',
    time: '48 分钟前',
    date: '2026-09-12 20:22',
    heat: 79100,
    comments: 5120,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20streaming%20studio%20corner%20with%20deep%20charcoal%20walls%20and%20a%20warm%20amber%20ring%20light%20glow%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20editorial%20photography%2C%20no%20people%20visible%2C%20film%20grain&width=800&height=560&seq=gg-cover-03&orientation=landscape',
    tags: ['更新', '直播', '回应'],
    author: '值班编辑 · 小满',
  },
  {
    id: 'n04',
    title: '都市剧大结局口碑两极，评分曲线在三天内持续下探',
    excerpt:
      '大结局播出当晚讨论量翻了三倍。有人认可收尾方式，也有观众列出前二十集埋下的伏笔认为没有回应。我们整理了被反复提到的六个争议点。',
    categoryId: 'film',
    categoryName: '影视剧',
    time: '1 小时前',
    date: '2026-09-12 19:58',
    heat: 71300,
    comments: 2330,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20empty%20cinema%20hall%20with%20deep%20charcoal%20seats%20and%20a%20faint%20crimson%20screen%20glow%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%20editorial%20style%2C%20no%20people%20visible&width=800&height=560&seq=gg-cover-04&orientation=landscape',
    tags: ['口碑', '影视', '争议'],
    author: '值班编辑 · 老周',
  },
  {
    id: 'n05',
    title: '音乐节档期临时调整，多支乐队行程同步出现变动',
    excerpt:
      '主办方在傍晚发布调整说明，随后几支乐队转发了各自的最新行程。截至目前，退票通道与改期方案已经同步公开。',
    categoryId: 'music',
    categoryName: '音乐现场',
    time: '2 小时前',
    date: '2026-09-12 18:40',
    heat: 56800,
    comments: 1420,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20outdoor%20music%20festival%20stage%20at%20night%20seen%20from%20afar%2C%20deep%20charcoal%20sky%20and%20warm%20amber%20stage%20light%20beams%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%2C%20no%20people%20visible&width=800&height=560&seq=gg-cover-05&orientation=landscape',
    tags: ['跟进', '音乐', '档期'],
    author: '值班编辑 · 阿灰',
  },
  {
    id: 'n06',
    title: '网传某演员更换经纪团队，站内标记为「待确认」并说明依据',
    excerpt:
      '这条信息目前只有两条来源，其中一条已被删除。按照本站内容原则，我们把它标记为待确认，并列出接下来需要观察的三个公开信号。',
    categoryId: 'ent',
    categoryName: '娱乐圈',
    time: '3 小时前',
    date: '2026-09-12 17:52',
    heat: 49700,
    comments: 1180,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20backstage%20corridor%20with%20deep%20charcoal%20walls%20and%20dim%20amber%20wall%20lights%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20editorial%20style%2C%20no%20people%20visible%2C%20film%20grain&width=800&height=560&seq=gg-cover-06&orientation=landscape',
    tags: ['核实', '待确认', '娱乐圈'],
    author: '核查组 · 小满',
  },
  {
    id: 'n07',
    title: '情感话题「异地三年」登上讨论榜，评论区出现大量真实经历',
    excerpt:
      '话题从一条投稿开始，随后大量读者在评论区写下自己的版本。我们挑出了被点赞最多的几类观点，并做了简单归类。',
    categoryId: 'life',
    categoryName: '情感八卦',
    time: '4 小时前',
    date: '2026-09-12 16:35',
    heat: 44200,
    comments: 3960,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20quiet%20apartment%20window%20at%20dusk%20with%20deep%20charcoal%20interior%20and%20warm%20amber%20lamp%20glow%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20editorial%20photography%2C%20no%20people%20visible&width=800&height=560&seq=gg-cover-07&orientation=landscape',
    tags: ['话题', '情感', '讨论'],
    author: '值班编辑 · 老周',
  },
  {
    id: 'n08',
    title: '短视频达人账号风格突变，粉丝翻出三个月前的团队变动线索',
    excerpt:
      '从运镜、剪辑节奏到字幕样式，最近七条内容几乎是另一种风格。粉丝整理出的时间线和账号过往的合作记录，让猜测越滚越大。',
    categoryId: 'web',
    categoryName: '网红圈',
    time: '5 小时前',
    date: '2026-09-12 15:20',
    heat: 38900,
    comments: 960,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20creative%20studio%20desk%20with%20deep%20charcoal%20walls%2C%20cold%20teal%20accent%20light%20and%20unused%20camera%20on%20tripod%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%2C%20no%20people%20visible&width=800&height=560&seq=gg-cover-08&orientation=landscape',
    tags: ['首发', '短视频', '风向'],
    author: '值班编辑 · 阿灰',
  },
  {
    id: 'n09',
    title: '全网热议的公共话题：一条热搜如何在半天内从质疑走向澄清',
    excerpt:
      '这个话题从早间出现，到傍晚基本形成共识，中间经历了三次明显的舆论转向。我们按时间顺序复盘了整个过程。',
    categoryId: 'hot',
    categoryName: '网络热点',
    time: '7 小时前',
    date: '2026-09-12 13:10',
    heat: 35500,
    comments: 2040,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20city%20skyline%20silhouette%20at%20night%20with%20deep%20charcoal%20sky%20and%20scattered%20warm%20window%20lights%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20editorial%20style%2C%20film%20grain&width=800&height=560&seq=gg-cover-09&orientation=landscape',
    tags: ['复盘', '热点', '公共话题'],
    author: '核查组 · 老周',
  },
];

export const articleBodies: Record<string, { type: 'p' | 'h2' | 'quote'; text: string }[]> = {
  n01: [
    { type: 'p', text: '事情最早出现在今天上午十点左右，一条画质模糊的路透截图开始在几个讨论群里流传。截图里只能看到几位嘉宾的背影和一块写着分组的白板，信息量有限，但足以让话题开始发酵。' },
    { type: 'h2', text: '第一个反转：路透被指「旧图」' },
    { type: 'p', text: '中午之前，有网友指出这张图的光线角度与上一季节目的棚内布景高度相似，怀疑是旧素材被重新发布。讨论一度转向「看图别急」。我们核对了公开可见的布景细节，确实存在两处与上一季一致的地方。' },
    { type: 'h2', text: '第二个反转：节目组深夜说明' },
    { type: 'p', text: '傍晚，节目组在官方账号发布了一段简短说明，确认新一季已完成首次录制，但未对分组内容做出任何确认。这条说明没有否认，也没有证实，等于把讨论重新交回给观众。' },
    { type: 'quote', text: '截至发稿，分组名单仍属于未经确认的信息，本站仅呈现公开可见的时间顺序，不代表任何一方立场。' },
    { type: 'h2', text: '接下来值得看什么' },
    { type: 'p', text: '按照往季节奏，正式物料通常会在录制后两到三周集中放出。在那之前，任何单张截图都建议先看来源再看内容。本站会持续跟进，并在信息状态发生变化时更新本条时间线。' },
  ],
  n02: [
    { type: 'p', text: '关键的第五局只用了二十三分钟。卫冕队伍在前期取得经济领先后连续两次团战失误，把优势一点点交了出去，最终以一分之差止步八强。' },
    { type: 'h2', text: '赛后发布会的那句话' },
    { type: 'p', text: '发布会上，教练用很短的句子回应了失利：「我们准备的东西，今天没打出来。」这句话被反复转发，评论区很快分成两派，一派认为是临场发挥问题，另一派则认为准备本身就存在偏差。' },
    { type: 'h2', text: '被翻出来的赛季初记录' },
    { type: 'p', text: '有观众整理了赛季初的阵容变动记录，指出核心位置的调整发生在常规赛开始前两周。这份整理本身没有结论，但为讨论提供了一个可核对的起点。' },
    { type: 'quote', text: '比赛结果已经确定，关于原因的分析仍属于观众讨论范畴，本站不提供任何内部消息。' },
  ],
  n03: [
    { type: 'p', text: '直播在晚上八点整开始，持续了两个半小时。主播大部分时间在与弹幕互动，中间分四次集中回应了此前的争议。' },
    { type: 'h2', text: '核心回应集中在四点' },
    { type: 'p', text: '四点分别是：合作关系的开始时间、相关款项的处理方式、聊天记录的完整性问题，以及后续是否继续合作。每一部分都对应了此前被公开讨论的具体内容。' },
    { type: 'h2', text: '两份说法的对照' },
    { type: 'p', text: '另一方的说明发布于三天前。我们把两份材料中可以直接对应的部分并列，发现关于时间点的描述基本一致，分歧主要集中在款项性质与沟通过程上。' },
    { type: 'quote', text: '由于双方均未提供完整凭证，本站对具体金额与责任归属不做判断，仅整理公开表述。' },
  ],
};